// extracted by mini-css-extract-plugin
module.exports = {"OpenNoteTrigger":"note-content_OpenNoteTrigger__syq0k","QuestionMark":"note-content_QuestionMark__giiHx"};